import AdminVideoList from "../../components/video/AdminVideoList";
function AdminVideoListPage(){

     return(
          <AdminVideoList />
     )
}

export default AdminVideoListPage;